<span>{{props?.label + (props?.required ? ' *': ' ')}}</span>
<div class="input-group" style="margin-top: 8px;">
    <input [formControl]="formControl" [formlyAttributes]="field" class="form-control" matInputPhoneNumber>
    <div class="invalid-feedback" *ngIf="!formControl.valid">
        Please enter a 10 digit number.
      </div>
</div>